import { FC } from "react";

import { Card } from "shared/components";
import { Globe } from "shared/assets/icons";
import { Spacer } from "shared/layout";
import { copy } from "shared/assets";

import { getRegionalSettingsActions, useBandRoute } from "Bands/utils";
import { useBandContext, usePermissionsContext } from "Bands/contexts";
import { MutedDarkText, MutedText } from "shared/styles";
import { BAND_PATHS } from "Bands/router";

const {
  bandSettings: { bandSettingsFormFields, bandSettingsIds, sidemenu, messages },
} = copy;

export const RegionalSettings: FC = () => {
  const { band } = useBandContext();
  const { pushRoute } = useBandRoute();
  const { bandPermissions } = usePermissionsContext();

  const handleEdit = () => {
    pushRoute(BAND_PATHS.EDIT_BAND_SETTINGS_REGIONAL);
  };

  const actions = bandPermissions.EDIT
    ? getRegionalSettingsActions({
        handleEdit,
      })
    : [];

  const items = [
    {
      title: bandSettingsFormFields.timeZone.title,
      value: band?.timeZone || messages.notProvided,
    },
    {
      title: bandSettingsFormFields.dateFormat.title,
      value: band?.dateFormat || messages.notProvided,
    },
    {
      title: bandSettingsFormFields.timeFormat.title,
      value: band?.timeFormat || messages.notProvided,
    },
  ];

  if (!band) return null;

  return (
    <Card
      id={bandSettingsIds.regional}
      title={sidemenu.regional}
      icon={Globe}
      actions={actions}
      actionDataTestId="regional_settings_actions"
    >
      <Spacer size="s">
        {items.map(({ title, value }, index) => (
          <span key={index}>
            <MutedDarkText>{title}: </MutedDarkText>
            <MutedText>{value}</MutedText>
          </span>
        ))}
      </Spacer>
    </Card>
  );
};
